import { render } from "./NotionComponent.vue?vue&type=template&id=14401ac1&scoped=true"
import script from "./NotionComponent.vue?vue&type=script&lang=js"
export * from "./NotionComponent.vue?vue&type=script&lang=js"

import "./NotionComponent.vue?vue&type=style&index=0&id=14401ac1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14401ac1"]])

export default __exports__